import React from "react";
import { useTranslation } from "react-i18next";
import "../SchedulingStyles/AppointmentFeeInput.css";

const AppointmentFeeInput = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="appointment-fee-container">
      <label htmlFor="appointment-fee">
        {t("admin_scheduling_new.appointment_fee_label")}
      </label>
      <input
        type="number"
        id="appointment-fee"
        min="0"
        step="0.01"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("admin_scheduling_new.appointment_fee_placeholder")}
      />
    </div>
  );
};

export default AppointmentFeeInput;
